<template>
    <div class="barL">
        <div class="con" v-for="(i,index) in dataExponentList" :key="index">
             <div style="color: #0358D2;font-size: 30px;font-weight: 600;">{{ i.value }}</div>
             <div style="color: #878786;font-size: 14px;">{{ i.label }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['dataExponentList'],
        data(){
            return{

            }
        }
    }
</script>

<style scoped>
.barL{
    grid-template-columns: repeat(4, 1fr);
    display: grid;
    background: #fff;
    border-radius: 10px;
    height: 100px;
}
.con{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
}
</style>